import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
// import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoaderComponent } from '@ui/components/laoder/loader.component';
import { Subject } from 'rxjs';
import { DynamicOverlay } from './dynamic-overlay.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private spinnerTopRef;
  private spin$: Subject<string> = new Subject();

  constructor(@Inject(DOCUMENT) document: Document, private dynamicOverlay: DynamicOverlay) {
    this.spin$.asObservable().subscribe(res => {
      if (this.spinnerTopRef) {
        if (res === 'show') {
          if (!this.spinnerTopRef.hasAttached()) {
            this.showSpinner();
          }
        } else if (res === 'hide') {
          if (this.spinnerTopRef.hasAttached()) {
            this.stopSpinner();
          }
        }
      }
    });
  }

  isAttached() {
    if (this.spinnerTopRef) {
      return this.spinnerTopRef.hasAttached();
    }
  }

  show() {
    if (this.spinnerTopRef) {
      this.spin$.next('show');
    } else {
      this.cdkSpinnerCreate();
      this.spin$.next('show');
    }
  }

  resetOverlayHeight() {
    if (this.spinnerTopRef) {
      (this.spinnerTopRef as OverlayRef).updatePositionStrategy(
        this.dynamicOverlay
          .position()
          .global()
          .centerHorizontally()
          .centerVertically()
      );
    } else {
      this.cdkSpinnerCreate();
      this.resetOverlayHeight();
    }
  }

  hide() {
    if (this.spinnerTopRef) {
      this.spin$.next('hide');
    }
  }

  resetOverlay() {
    this.spinnerTopRef = null;
  }

  cdkSpinnerCreate() {
    const elementRef = document.getElementById('main-container');
    this.dynamicOverlay.setContainerElement(elementRef);
    const height = window.innerHeight;

    this.spinnerTopRef = this.dynamicOverlay.create({
      positionStrategy: this.dynamicOverlay
        .position()
        .global()
        .centerHorizontally()
        .top(height / 2 - 50 + 'px'),
      hasBackdrop: true,
      backdropClass: 'dark-backdrop'
    });
  }

  private showSpinner() {
    this.spinnerTopRef.attach(new ComponentPortal(LoaderComponent));
  }

  private stopSpinner() {
    this.spinnerTopRef.detach();
  }
}
